import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    limit: PropTypes.number,
    query: PropTypes.shape({}),
  },
  {
    isCarousel(ac) {
      return this.type(ac) === "Carousel";
    },

    isList(ac) {
      return this.type(ac) === "List";
    },
    queryTerm(ac) {
      return ac?.query?.query;
    },
  },
);
